export default function trackError(error: any) {
  console.error(error);

  // @ts-ignore
  if (global.trackJs) {
    // @ts-ignore
    global.trackJs.track(error);
  }
}
